export const innerDiameterOptions = <const>[
	400,
	508,
	610,
	762
];

export type AdditionalDataChoices = 'coilOuterDiameter' | 'coilWeight' | 'coilLength' | 'specificWeight';

export const METALLIC_COATING_TYPE_OPTIONS_KEYS = <const> [
	7.14,
	6.5
];

export const METALLIC_COATING_TYPE_OPTIONS = <const> {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	7.14: { label: 'Galvanized (Z)' },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	6.5: { label: 'Optigal (ZMO)' }
};

export const HOT_OR_COLD_ROLLED = 'hotOrColdRolled';
export const ORGANIC_COATED_STEEL = 'organicCoatedSteel';
